import React from 'react';
import { Dropdown, Tooltip } from 'antd';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { ReactComponent as SortIcon } from '../../assets/icons/sort-icon.svg';
import { safeExtractFromObject } from '../../helpers/helpers';
import OnTraccrButton from '../buttons/OnTraccrButton';

import { getSortMenu } from './helpers';

function CardGridButton({
  sortOptions,
  sortActive,
}) {

  const settings = useSelector((state) => safeExtractFromObject(state, 'settings.company.settings'));
  const hasRedesign = settings?.uxRedesignPt1;
  return (
    <Tooltip title="Sort">
      <Dropdown overlay={getSortMenu(sortOptions, sortActive)}>
        <OnTraccrButton
          type="cancel"
          title={hasRedesign ? '' : 'Sort'}
          icon={hasRedesign ? <SortIcon style={{ marginLeft: -7, marginTop: 3 }} /> : undefined}
          style={hasRedesign ? { width: 32, height: 32 } : {}}
        />
      </Dropdown>
    </Tooltip>
  );
}

CardGridButton.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  sortOptions: PropTypes.array.isRequired,
  sortActive: PropTypes.string.isRequired,
};

export default CardGridButton;
